<template>
  <div>
    <v-card>
      <v-toolbar card>
        <v-select
          :items="clazzes"
          v-model="pagination.clazz"
          label="Type"
          single-line required
        ></v-select>
        <v-spacer></v-spacer>
        <v-select
          :items="statuses"
          v-model="pagination.status"
          label="Status"
          single-line
        ></v-select>
        <v-spacer></v-spacer>
        <rangedate-picker @selected="onDateSelected" righttoleft="true" i18n="EN" ref="dateSelected"></rangedate-picker>
        <v-btn flat icon color="grey" @click.native.stop="onClearDateSelected">
          <v-icon>cancel</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
      <v-data-table :loading="loading"
          :headers="headers"
          :items="loadedItems"
          :total-items="pagination.totalItems"
          :pagination.sync="pagination"
          @update:pagination="reload"
          class="elevation-0"
          hide-actions
        >
        <v-progress-linear slot="progress" color="lime" indeterminate></v-progress-linear>
        <template slot="items" slot-scope="props">
          <td class="text-xs-center">{{ props.index + 1 }}</td>
          <td class="text-xs-left" nowrap>{{ props.item.code }}</td>
          <td class="text-xs-left">{{ props.item.name }}</td>
          <td class="text-xs-left">{{ props.item.customer.name }}</td>
          <td class="text-xs-center">{{ props.item.bookDate | formatShortDate }}</td>
          <td class="text-xs-right">{{ props.item.totalPriceAmount | currency('',2) }}</td>
          <td class="text-xs-right">{{ props.item.totalVatAmount | currency('',2) }}</td>
          <td class="text-xs-right">{{ props.item.totalAmount | currency('',2) }}</td>
          <td class="text-xs-center">
            <v-chip small outline :color="$options.filters.statusBgColor(props.item.status)">{{ props.item.status }}</v-chip>
          </td>
        </template>
        <template slot="footer">
          <td class="text-xs-right" colspan="5">
            Total
          </td>
          <td class="text-xs-right">
            {{ this.sumTotalPriceAmount | currency('',2) }}
          </td>
          <td class="text-xs-right">
            {{ this.sumTotalVatAmount | currency('',2) }}
          </td>
          <td class="text-xs-right">
            {{ this.sumTotalAmount | currency('',2) }}
          </td>
          <td></td>
        </template>
      </v-data-table>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import _ from 'lodash'
import swal from 'sweetalert2'
import moment from 'moment'
import RangedatePicker from 'vue-rangedate-picker'

export default {
  name: 'Report',
  components: {
    RangedatePicker
  },
  data() {
    return {
      loading: false,
      valid: false,
      clazzes: [
        { text: 'Quotation', value: 'th.co.netplus.invoice.Quotation' },
        { text: 'Invoice', value: 'th.co.netplus.invoice.Invoice' },
        { text: 'CashBill', value: 'th.co.netplus.invoice.CashBill' },
        { text: 'Receipt', value: 'th.co.netplus.invoice.Receipt' }
      ],
      statuses: [
        { text: 'ALL', value: '' },
        { text: 'DRAFT', value: 'DRAFT' },
        { text: 'COMPLETED', value: 'COMPLETED' }
      ],
      headers: [
        { text: '#', sortable: false, align: 'center' },
        { text: 'Code', value: 'code', sortable: true, align: 'left' },
        { text: 'Name', value: 'name', sortable: true, align: 'left' },
        { text: 'Customer', value: 'customer.name', sortable: true, align: 'left'},
        { text: 'Date', value: 'bookDate', sortable: true, align: 'center' },
        { text: 'Price', value: 'totalPriceAmount', sortable: false, align: 'right' },
        { text: 'Vat', value: 'totalVatAmount', sortable: false, align: 'right' },
        { text: 'Total', value: 'totalAmount', sortable: false, align: 'right' },
        { text: 'Status', value: 'status', sortable: true, align: 'center' }
      ],
      pagination: {
        clazz: null,
        status: null,
        startDate: '',
        endDate: '',
        sortBy: 'bookDate',
        descending: true,
        totalItems: 0
      },
      totalAmount: 0,
      loadedItems: []
    }
  },
  computed: {
    sumTotalPriceAmount(){
      if(this.loadedItems)
        return this.loadedItems.reduce((accumulator, currentValue) => accumulator + currentValue.totalPriceAmount, 0)
      else
        return 0.0
    },
    sumTotalVatAmount(){
      if(this.loadedItems)
        return this.loadedItems.reduce((accumulator, currentValue) => accumulator + currentValue.totalVatAmount, 0)
      else
        return 0.0
    },
    sumTotalAmount(){
      if(this.loadedItems)
        return this.loadedItems.reduce((accumulator, currentValue) => accumulator + currentValue.totalAmount, 0)
      else
        return 0.0
    }
  },
  methods: {
    onClearDateSelected() {
      this.$refs.dateSelected.dateRange = { start: '', end: '' }
      this.pagination.startDate = ''
      this.pagination.endDate = ''
      this.reload(this)
    },
    onDateSelected(daterange) {
      this.pagination.startDate = moment(daterange.start).format('YYYY-MM-DD')
      this.pagination.endDate = moment(daterange.end).format('YYYY-MM-DD')
      this.reload(this)
    },
    reload: _.debounce((self) => {
      if (!self.pagination || !self.pagination.clazz) return
      self.loading = true
      self.$store
        .dispatch('report/loadItems', self.pagination)
        .then(response => {
          self.pagination = {
            clazz: response.data.clazz,
            status: response.data.status,
            sortBy: response.data.sortBy,
            descending: response.data.descending,
            totalItems: response.data.totalItems,
            startDate: response.data.startDate ? response.data.startDate : '',
            endDate: response.data.endDate ? response.data.endDate : ''
          }
          self.totalAmount = response.data.totalAmount
          self.loadedItems = response.data.items
          self.loading = false
        })
        .catch(error => {
          self.loading = false
          swal('Error!', error.message, 'error')
        })
    }, 1000)
  },
  watch: {
    'pagination.clazz'() {
      if (this.pagination.clazz) this.reload(this)
    },
    'pagination.status'() {
      this.reload(this)
    },
    'pagination.descending'() {
      this.reload(this)
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/views/reports/index.vue